import axios from "axios";
import { apiUrl, PORT } from "../../environment";
// import { getInfo } from "./Auth.header";
import queryString from "query-string";
import { toast } from "react-toastify";
import axiosClient from "../../admin/services/axiosClient";


export const fetchPrivacyPolicy = async (params) => {
  try {
    const response = await axiosClient.get(`/user-service/privacy-policy`);

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    console.error("Error fetching total patient count:", err);
    toast.error("An error occurred while fetching templates.");
  }
};

export const fetchTermsAndCondition = async (params) => {
  try {
    const response = await axiosClient.get(`/user-service/terms-condition`);

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    console.error("Error fetching total patient count:", err);
    toast.error("An error occurred while fetching templates.");
  }
};

export const savePrivacyPolicy = async (data, id = null) => {
  try {

    const response = await axiosClient.post(`/user-service/privacy-policy`, data);



    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching templates.");
  }
};

export const saveTermsAndCondtions = async (data, id = null) => {
  try {
    const response = await axiosClient.post(`/user-service/terms-condition`, data);
    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching templates.");
  }
};